import { type Reducer, type Action } from "redux";

export function createReducer<StateType, ActionType extends Action = Action>(
  initialState: StateType,
  handlers: Array<() => Record<string, (state: StateType, action: any) => StateType>>,
): Reducer<StateType, ActionType> {
  const handler = Object.assign({}, ...handlers.map((item) => item()));

  return function reducer(state: StateType = initialState, action: ActionType): StateType {
    if (Object.prototype.hasOwnProperty.call(handler, action.type)) {
      return handler[action.type](state, action);
    } else {
      return state;
    }
  };
}

export function mergeReducers<StateType, ActionType extends Action = Action>(
  parentReducer: Reducer<StateType, ActionType>,
  nextReducer: (state: StateType, action: ActionType) => StateType,
): Reducer<StateType, ActionType> {
  return (state: StateType | undefined, action: ActionType): StateType => {
    const intermediateState = parentReducer(state, action);

    return nextReducer(intermediateState, action);
  };
}
